import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {axiosInstance, axiosAmarlabInstance} from '../components/helper/axiosConfig';
import { isAdmin, isDoctor } from '../components/helper/authRoles';
import toast, { Toaster } from 'react-hot-toast';

const InvestigationUploadModal = ({ closeModal }) => {
  const { prescription_id } = useParams(); // Get the prescription ID from the URL
  const [prescription, setPrescription] = useState(null); // Store prescription data
  const [investigations, setInvestigations] = useState([]); // Store investigation list
  const [files, setFiles] = useState({});
  const [notes, setNotes] = useState({});
  const [reports, setReports] = useState({});
  const [amarlabDiagnostic, setAmarlabDiagnostic] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch prescription data
  // Fetch prescription data
  const fetchPrescription = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/api/prescription/${prescription_id}`
      );
      setPrescription(response.data);

      // Split investigations if available and filter out empty or invalid items
      if (response.data?.investigations) {
        const rawInvestigations = response.data.investigations.split(",");
        const filteredInvestigations = rawInvestigations
          .map((item) => item.trim()) // Normalize by trimming spaces
          .filter((item) => item); // Remove empty or invalid items
        setInvestigations(filteredInvestigations);
      } else {
        setInvestigations([]);
      }
    } catch (error) {
      console.error("Error fetching prescription:", error);
    }
  };

  const fetchAmarlabPrescription = async () => {
    try {
      const orderResponse = await axiosAmarlabInstance.get(
        '/order/sneho-order-tree/',
        {
          params: {
            from_sneho: 1,
            sneho_prescription_id: prescription_id,
          },
        }
      );
      const diagnosticData =  orderResponse.data?.results || []
      console.log("the prescription data is = ", diagnosticData)
      setAmarlabDiagnostic(diagnosticData);
    } catch (error) {
      console.error(
        `Error fetching diagnostic data for prescription ID ${prescription.id}:`,
        error
      );
      prescription.diagnostic = []; // Default to an empty array on error
    }
  };

  useEffect(() => {
    fetchPrescription();
    fetchAmarlabPrescription();
  }, [prescription_id]);

  // Fetch investigation reports
  const fetchReports = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/api/investigation-report-prescription/${prescription_id}`
      );
      const data = response.data;

      // Group reports by the "name" field
      const groupedReports = {};
      data.forEach((report) => {
        const reportName = report.name?.trim(); // Ensure the name is trimmed
        if (reportName) {
          if (!groupedReports[reportName]) {
            groupedReports[reportName] = [];
          }
          groupedReports[reportName].push(report);
        }
      });

      console.log("The grouped reports are: ", groupedReports);
      setReports(groupedReports);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reports:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrescription();
    fetchReports();
  }, [prescription_id]);


  // Update file for a specific investigation
  const handleFileChange = (index, file) => {
    setFiles({ ...files, [index]: file });
  };

  // Update note for a specific investigation
  const handleNoteChange = (index, note) => {
    setNotes({ ...notes, [index]: note });
  };

  // Handle upload
  const handleUpload = async (index) => {

    const file = files[index];
    const userId = JSON.parse(localStorage.getItem("user"))?.id;

    if (!file) {
      toast.error('Please select a file before uploading!', {
        autoClose: 3000,
      });
      return;
    }
    const formData = new FormData();
    formData.append("prescription", prescription_id);
    formData.append("name", investigations[index]);
    formData.append("report", file);
    formData.append("note", notes[index] || "");

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/api/investigation-report/`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success('Upload successful!', {
        autoClose: 3000,
      });

      console.log(response.data);
      fetchReports();
    } catch (error) {
      console.error(error);
      toast.error('Upload failed. Please try again.', {
        autoClose: 3000,
      });
    }
  };

  // Render loading state if prescription is not loaded
  if (!prescription) {
    return <div>Loading...</div>;
  }

  return (
    <div className="modal p">
    <div class="modal-dialog pd">
      <div className="modal-header pph">
        <h2>Upload Investigation (Reports)</h2>
        <button className="close-button ppc" onClick={closeModal}>
          &times;
        </button>
      </div>
      <div className="modal-content pp">
        {investigations.length > 0 ? (
          investigations.map((item, index) => (
            <div key={index} className="investigation-upload-wrapper">
              <p>
                <b>Investigation:</b> {item}
              </p>
            {isAdmin() && (
              <>
              <input
                type="file"
                onChange={(e) => handleFileChange(index, e.target.files[0])}
              />
              <textarea
                placeholder="Add a note (optional)"
                onChange={(e) => handleNoteChange(index, e.target.value)}
              ></textarea>
              <button className="up-btn" onClick={() => handleUpload(index)}>Upload</button>
              </>
            )}
              {/* Display Report List */}
               <div>
               <h4 className="pp-list">Report List:</h4>
               {loading ? (
                 <p>Loading...</p>
               ) : reports[item] && reports[item].length > 0 ? (
                 <ul className="pp-ul">
                   {reports[item].map((report, idx) => (
                     <li key={idx}>
                       <a href={`${process.env.REACT_APP_AXIOS_BASE_URL}${report.report}`} target="_blank" rel="noopener noreferrer">
                         {report.name || "Unknown File Name"}
                       </a>
                       {report.note && <p>Note: {report.note}</p>}
                     </li>
                   ))}
                 </ul>
               ) : (
                 <p>No reports available for this investigation.</p>
               )}
               </div>


            </div>
          ))
        ) : (
          <p>No investigations available.</p>
        )}
        <>
          {amarlabDiagnostic
            .flatMap((order) => order.orderreport) // Combine all orderreport arrays
            .map((report) => (
              <>
              <h6 style={{ margin:"5px 0" }}>From Amarlab</h6>
              <ul key={report.id} className="pp-ul">
              <li>
                {report.tests} (
                    <a
                      style={{ color: "#3c84c5", textDecoration: "none" }}
                      href={report.report}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {report.name}
                    </a>
                )
                </li>
              </ul>
              </>
            ))}
          </>
      </div>
    </div>
    </div>
  );
};

export default InvestigationUploadModal;
